import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { OrganizationService } from '../organization.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'delete-organization',
  providers: [
    OrganizationService, TranslateService
  ],
  template: require('./organization-delete.html')
})
export default class DeleteOrganization {
  @Input('isVisible') isVisible: boolean;
  @Input('orgData') orgData;
  @Output('onClose') selfClose = new EventEmitter();

  private subscription: Subscription;
  private active: boolean = true;
  private formData: Object = {};
  private isOperationInProgress: boolean = false;
  private isErrorShown: boolean = false;
  private errorMsg: string = "";
  private alertType: string = "alert-danger";
  private isSubmitDisabled: boolean = false;

  constructor(public organizationService: OrganizationService,
              private translateService: TranslateService) {
    translateService.use(GlobalVariables.LOCALE);
    this.formData = this.orgData;
  }
  ngOnInit() {
    this.formData = this.orgData;
    this.reset();
  }
  ngOnChanges(changes) {
    this.formData = this.orgData;
    this.reset();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  cancel() {
    this.closeSelf();
  }
  // Workaround until form has a reset method
  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
    this.errorMsg = '';
    this.isErrorShown = false;
    this.isSubmitDisabled = false;
  }
  onSubmit(f: NgForm) {
    if ( this.orgData ) {
        this.deleteOrg(this.orgData);
    }
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: 'close'
      });
    }
  }

  deleteOrg(obj) {
    if (obj && obj.organization) {
      this.isOperationInProgress = true;
      this.subscription = this.organizationService.deleteOrg(obj.organization)
        .subscribe(
          (res: any) => {
            if(res.hasOwnProperty('error') && res.error && res.hasOwnProperty('errorMessage') && res.errorMessage !== '') {
              this.errorMsg = res.errorMessage.replace(/\[(.*?)\]/gi, "");
              this.alertType = "alert-danger";
              this.isErrorShown = true;
              this.isSubmitDisabled = true;
            }
            else {
              this.closeSelf();
            }
            this.isOperationInProgress = false;
          },
          error => {
            this.isOperationInProgress = false;
            this.logError(error, 'delete Org');
          },
          () => this.logOperationCompleted('delete Org')
        );
    } else {
      this.logError('Org Id could not be found');
    }
  }
  logError(error, origin: String = '') {
    console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }
  logOperationCompleted(msg: string) {
    this.isOperationInProgress = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/organization/delete/organization-delete.component.ts